import { Callout } from "components/ui/callout";
import * as React from "react";

interface ActionBarChildrenParams {
    close: () => void;
}

interface IActionBarComponentProps {
    label: string;
    value: string;
    children?: ((params: ActionBarChildrenParams) => React.ReactNode) | React.ReactNode;
}

export const ActionBarComponent: React.FunctionComponent<IActionBarComponentProps> = (
    props: IActionBarComponentProps,
) => {
    const { label, value, children } = props;
    const [isCalloutOpen, setIsCalloutOpen] = React.useState(false);
    const openCallout = React.useCallback(() => {
        setIsCalloutOpen(true);
    }, [setIsCalloutOpen]);

    const renderButton = React.useCallback(() => {
        return (
            <div onClick={openCallout}>
                <button
                    type="button"
                    className={`rounded-full bg-blue-50 px-3 py-1 flex items-center gap-2 shadow border border-gray-200 text-sm font-medium text-gray-800 hover:bg-blue-100 transition`}
                    aria-label={label}>
                    <span className="font-semibold">{value}</span>
                </button>
            </div>
        );
    }, [label, value, openCallout]);

    const params = React.useMemo(() => {
        return {
            close: () => {
                setIsCalloutOpen(false);
            },
        };
    }, [setIsCalloutOpen]);

    return (
        <Callout
            renderButton={renderButton}
            onOpen={openCallout}
            forceClose={!isCalloutOpen}>
            <div className="w-80">
                {typeof children === "function" ? children(params) : children}
            </div>
        </Callout>
    );
};
